import { render, staticRenderFns } from "./PersonalCenterSidebar.vue?vue&type=template&id=960ec14e&scoped=true&"
import script from "./PersonalCenterSidebar.vue?vue&type=script&lang=js&"
export * from "./PersonalCenterSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCenterSidebar.vue?vue&type=style&index=0&id=960ec14e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960ec14e",
  null
  
)

export default component.exports